import React from 'react';

const StatsCard = ({ title, value, icon: Icon, variant = 'default' }) => {
  const variantStyles = {
    default: { iconBg: '#f5f5f7', iconColor: '#6e6e73' },
    success: { iconBg: 'rgba(52, 199, 89, 0.12)', iconColor: '#248a3d' },
    warning: { iconBg: 'rgba(255, 149, 0, 0.12)', iconColor: '#c93400' },
    error: { iconBg: 'rgba(255, 59, 48, 0.12)', iconColor: '#d70015' },
    info: { iconBg: 'rgba(0, 113, 227, 0.12)', iconColor: '#0071e3' },
  };

  const colors = variantStyles[variant] || variantStyles.default;

  return (
    <div style={styles.card}>
      <div style={{ ...styles.iconWrapper, background: colors.iconBg }}>
        <Icon size={20} color={colors.iconColor} />
      </div>
      <div style={styles.content}>
        <span style={styles.value}>{value}</span>
        <span style={styles.title}>{title}</span>
      </div>
    </div>
  );
};

const styles = {
  card: {
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
    padding: '20px 24px',
    background: '#ffffff',
    borderRadius: '12px',
    border: '1px solid #e8e8ed',
  },
  iconWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '44px',
    height: '44px',
    borderRadius: '10px',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
  },
  value: {
    fontSize: '24px',
    fontWeight: '600',
    color: '#1d1d1f',
    letterSpacing: '-0.5px',
  },
  title: {
    fontSize: '13px',
    color: '#86868b',
    marginTop: '2px',
  },
};

export default StatsCard;